export default {"src":"/_next/static/media/flow-2.d79b5f3c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};